module.exports = __webpack_public_path__ + "static/img/son2.f16ea783.png";